import { RedoShopifyCountryCode } from "@redotech/redo-inventory-common/fulfillment-country-code";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
export enum MerchantCarrierReturnLabelMode {
  ONLY_REDO_CARRIERS = "only-redo-carriers",
  ONLY_SOME_COUNTRIES = "only-some-countries",
  ALWAYS = "always",
  CHEAPEST_OF_REDO_OR_MERCHANT = "cheapest-of-redo-or-merchant",
}

const MerchantCarrierReturnLabelSettingsSchema_ = z.object({
  mode: createEnum(MerchantCarrierReturnLabelMode, {
    enumName: "MerchantCarrierReturnLabelMode",
  }),
  whitelistedCountries: z.array(
    createEnum(RedoShopifyCountryCode, { enumName: "RedoShopifyCountryCode" }),
  ),
});
export const MerchantCarrierReturnLabelSettingsSchema: z.ZodType<MerchantCarrierReturnLabelSettings> =
  MerchantCarrierReturnLabelSettingsSchema_;
export interface MerchantCarrierReturnLabelSettings extends z.infer<
  typeof MerchantCarrierReturnLabelSettingsSchema_
> {}
